/**
 * ============================================================
 * NO ORDINARY MOMENTS — Auto-Add Free Gifts via Opus Button
 * ============================================================
 * 
 * v7 — Smart opt-out: only when customer manually deletes gift
 * 
 * SETUP:
 * 1. Paste into: Online Store → Themes → Edit Code → 
 *    Assets → Create "free-gift-auto-add.js"
 * 2. In theme.liquid, add before </body>:
 *    <script src="{{ 'free-gift-auto-add.js' | asset_url }}" defer></script>
 * ============================================================
 */

(function () {
  'use strict';

  // ===================== CONFIGURATION =====================
  const CONFIG = {
    shadowHostSelector: '#opus-shadow-container',
    clickDelay: 800,
    clickCooldown: 3000,
    debug: true,  // Set false for production

    gifts: [
      {
        name: 'Milk Frother',
        productId: 15199988318591,
        buttonSelector: '.cd-carousel-product.freegift.id15199988318591 button.cd-buy-button.freegift'
      },
      {
        name: 'No Ordinary Tote Bag',
        productId: 7867402911894,
        buttonSelector: '.cd-carousel-product.freegift.id7867402911894 button.cd-buy-button.freegift'
      }
    ]
  };
  // ==========================================================

  // Per-gift state
  const giftState = {};
  CONFIG.gifts.forEach(gift => {
    giftState[gift.productId] = {
      optedOut: false,
      clickInProgress: false,
      lastClickTime: 0
    };
  });

  function log(...args) {
    if (CONFIG.debug) console.log('[FreeGift]', ...args);
  }

  function getShadowRoot() {
    const host = document.querySelector(CONFIG.shadowHostSelector);
    return host?.shadowRoot || null;
  }

  function shadowQuery(selector) {
    const root = getShadowRoot();
    return root ? root.querySelector(selector) : null;
  }

  /**
   * Try to auto-click a gift's button.
   */
  function tryClickGift(gift) {
    const state = giftState[gift.productId];
    if (state.optedOut || state.clickInProgress) return;

    // Cooldown check
    const now = Date.now();
    if (now - state.lastClickTime < CONFIG.clickCooldown) return;

    const button = shadowQuery(gift.buttonSelector);
    if (!button) return;

    state.clickInProgress = true;
    log(gift.name + ': found button — auto-clicking in ' + CONFIG.clickDelay + 'ms...');

    setTimeout(() => {
      if (state.optedOut) {
        state.clickInProgress = false;
        return;
      }

      const btn = shadowQuery(gift.buttonSelector);
      if (!btn) {
        log(gift.name + ': button gone before click');
        state.clickInProgress = false;
        return;
      }

      btn.click();
      state.lastClickTime = Date.now();
      state.clickInProgress = false;
      log(gift.name + ': clicked!');

    }, CONFIG.clickDelay);
  }

  function checkAllGifts() {
    CONFIG.gifts.forEach(tryClickGift);
  }

  /**
   * Listen for clicks on gift delete buttons in the cart.
   * Opt out only when customer manually clicks the trash icon.
   */
  function listenForGiftDeletion(shadowRoot) {
    shadowRoot.addEventListener('click', (e) => {
      const deleteBtn = e.target.closest('.cd-product-item-delete');
      if (!deleteBtn) return;

      const itemContent = deleteBtn.closest('.cd-product-item-content');
      if (!itemContent) return;

      const classList = itemContent.className;
      for (const gift of CONFIG.gifts) {
        if (classList.includes('pro' + gift.productId) || classList.includes('id' + gift.productId)) {
          log(gift.name + ': customer clicked delete — opting out permanently');
          giftState[gift.productId].optedOut = true;
          return;
        }
      }
    });

    log('Gift deletion listener active');
  }

  /**
   * Observe shadow DOM for changes.
   */
  function observeShadowDOM() {
    const hostObserver = new MutationObserver(() => {
      const host = document.querySelector(CONFIG.shadowHostSelector);
      if (host?.shadowRoot) {
        startShadowObserver(host.shadowRoot);
        checkAllGifts();
      }
    });

    hostObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    const host = document.querySelector(CONFIG.shadowHostSelector);
    if (host?.shadowRoot) {
      log('Shadow root found');
      startShadowObserver(host.shadowRoot);
    }
  }

  let shadowObserverStarted = false;

  function startShadowObserver(shadowRoot) {
    if (shadowObserverStarted) return;
    shadowObserverStarted = true;

    const observer = new MutationObserver(() => {
      checkAllGifts();
    });

    observer.observe(shadowRoot, {
      childList: true,
      subtree: true
    });

    listenForGiftDeletion(shadowRoot);

    log('Shadow DOM observer active');
  }

  /**
   * Initialise.
   */
  async function init() {
    log('Initialising free gift auto-click (v7)...');

    observeShadowDOM();
    checkAllGifts();

    log('Ready! Tracking ' + CONFIG.gifts.length + ' gifts.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();